import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const AboutCTA = () => {
  const navigate = useNavigate();

  return (
    <section data-testid="about-cta-section" className="bg-baseLight px-6 pt-[30px] pb-[30px] sm:pt-[32px] sm:pb-[32px] lg:px-12 lg:pt-[48px] lg:pb-[78px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.55 }}
        data-testid="about-cta-panel"
        className="mx-auto max-w-[1280px] rounded-3xl bg-glacier px-6 py-14 text-center sm:px-10 sm:py-16 lg:px-16 lg:py-20"
      >
        <h2
          data-testid="about-cta-headline"
          className="mx-auto max-w-xl font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:max-w-3xl lg:text-[41px]"
        >
          Let's start with your operation
        </h2>
        <p data-testid="about-cta-text" className="mx-auto mt-[32px] lg:mt-5 max-w-lg text-[15px] leading-relaxed text-inkSoft">
          Tell us about your site, current energy use, grid constraints, diesel consumption and
          backup requirements.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-start gap-x-7 gap-y-4 lg:justify-center">
          <button
            type="button"
            data-testid="about-cta-button"
            onClick={() => navigate("/#contact")}
            className="inline-flex h-11 items-center gap-2 bg-teal text-white text-sm font-medium rounded-full px-7 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
          >
            Request a Farm Energy Assessment
          </button>
          <Link
            to="/applications"
            data-testid="about-cta-secondary-link"
            className="group mx-auto sm:mx-0 inline-flex items-center gap-1.5 text-sm font-medium text-teal hover:text-tealHover transition-colors duration-300"
          >
            Explore Applications
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </motion.div>
    </section>
  );
};
